import { Component, computed, inject } from '@angular/core';
import { RouterLink } from '@angular/router';
import { IconeServicoComponent } from '../../../../shared/components/icone-servico/icone-servico.component';
import { LucideModule } from '../../../../shared/modules/lucide.module';
import { CategoriasPublicasService } from '../../services/categorias-publicas.service';

/** Duas linhas de quatro na grade da seção. A tela `/categorias-servicos` mostra as demais. */
const CATEGORIAS_NA_HOMEPAGE = 8;

@Component({
  selector: 'app-categorias-servicos',
  templateUrl: './categorias-servicos.component.html',
  styleUrls: ['./categorias-servicos.component.css'],
  imports: [IconeServicoComponent, RouterLink, LucideModule],
})
export class CategoriasServicosComponent {
  private readonly categoriasPublicasService = inject(CategoriasPublicasService);

  /**
   * As primeiras categorias publicadas do órgão, na ordem editorial do adm, inclusive a sem
   * serviço (decisão de 21/10/2026). A categoria não tem campo de destaque: quem escolhe as
   * que aparecem aqui é a ordem de exibição do cadastro.
   *
   * Carregando, em falha ou sem catálogo, a lista vem vazia, e a seção não aparece.
   */
  readonly categoriaServicos = computed(() =>
    this.categoriasPublicasService.categorias().slice(0, CATEGORIAS_NA_HOMEPAGE)
  );
}
